/* eslint-disable import/no-anonymous-default-export */
import { Wizard_Mode } from '../../shared/enums'
import { IProtocol, IFile } from '../../shared/interfaces'
import {
    ProtocolWizardActionTypes, ProtocolWizardReduxState,
    SET_WIZARD_DOCUMENT_FILE, SET_WIZARD_INITIAL_STATE, SET_WIZARD_PROTOCOL, ADD_WIZARD_ATTACHMENT, UPDATE_WIZARD_PROTOCOL_STATE,
    SET_WIZARD_PROTOCOL_TOUCHED, UPDATE_WIZARD_ATTACHMENT, SET_WIZARD_ATTACHMENTS, SET_WIZARD_SELECTED_PRINTER_NAME,
    SET_WIZARD_DOCUMENT_SCANNER_LOADER, SET_WIZARD_ATTACHMENT_SCANNER_LOADER
} from './types'



const setInitialState = (wizardMode: Wizard_Mode): ProtocolWizardActionTypes => {
    return {
        type: SET_WIZARD_INITIAL_STATE,
        wizardMode: wizardMode
    }
}
const setDocumentFile = (documentFile: IFile | undefined): ProtocolWizardActionTypes => {
    return {
        type: SET_WIZARD_DOCUMENT_FILE,
        documentFile: documentFile
    }
}
const setAttachments = (attachmentsFile: IFile[]): ProtocolWizardActionTypes => {
    return {
        type: SET_WIZARD_ATTACHMENTS,
        attachmentsFile: attachmentsFile
    }
}
const addAttachment = (attachmentFile: IFile): ProtocolWizardActionTypes => {
    return {
        type: ADD_WIZARD_ATTACHMENT,
        attachmentFile: attachmentFile
    }
}
const updateAttachment = (attachmentFile: IFile): ProtocolWizardActionTypes => {
    return {
        type: UPDATE_WIZARD_ATTACHMENT,
        attachmentFile: attachmentFile
    }
}
const setProtocol = (protocol: IProtocol): ProtocolWizardActionTypes => {
    return {
        type: SET_WIZARD_PROTOCOL,
        protocol: protocol
    }
}

const setDocumentScannerLoader = (showDocumentLoader: boolean): ProtocolWizardActionTypes => {
    return {
        type: SET_WIZARD_DOCUMENT_SCANNER_LOADER,
        documentScannerLoader: showDocumentLoader
    }
}

const setAttachmentScannerLoader = (showAttachmentLoader: boolean): ProtocolWizardActionTypes => {
    return {
        type: SET_WIZARD_ATTACHMENT_SCANNER_LOADER,
        attachmentScannerLoader: showAttachmentLoader
    }
}

const setSelectedPrinterName = (selectedPrinterName: string): ProtocolWizardActionTypes => {
    return {
        type: SET_WIZARD_SELECTED_PRINTER_NAME,
        selectedPrinterName: selectedPrinterName
    }
}

const updateProtocolWizardState = (newState: Partial<ProtocolWizardReduxState>): ProtocolWizardActionTypes => {
    return {
        type: UPDATE_WIZARD_PROTOCOL_STATE,
        payload: newState
    }
}
const setProtocolWizardTouched = (): ProtocolWizardActionTypes => {
    return {
        type: SET_WIZARD_PROTOCOL_TOUCHED,
    }
}

export default {
    setInitialState,
    setDocumentFile,
    setAttachments,
    addAttachment,
    updateAttachment,
    setProtocol,
    setSelectedPrinterName,
    updateProtocolWizardState,
    setProtocolWizardTouched,
    setDocumentScannerLoader,
    setAttachmentScannerLoader
}